import styled from 'styled-components';

const getWidth = (props) => `${props.size * 4}px`;

const StyledSpace = styled.div`
  width: ${(props) => getWidth(props)};
`;
export default StyledSpace;
